import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";

import {FormWrapper} from "../items/form.wrapper";

@Component({
  selector: 'acc-form-footer',
  imports: [
    TranslatePipe
],
  templateUrl: './form-footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './form-footer.component.css'
})
export class FormFooterComponent {

  @Input({required: true})
  public wrapper!: FormWrapper;

  @Input()
  public showFooter: boolean = true;

  protected isViewOnly(): boolean {
    return this.wrapper.isViewOnly();
  }
}
